module.exports = __webpack_public_path__ + "static/img/inventario_cajasecas.7bf22b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/inventario_cajasecas.png
// module id = 92
// module chunks = 0